import React from 'react';
import {
  GhostArticle,
  FacebookShareButton,
  PinterestShareButton,
  TwitterShareButton,
  EmailShareButton,
  ghost,
} from '@minerva-analytics/pantheon';
import { ThemeProvider } from 'styled-components';

import SubscribeForm from '../../components/SubscribeForm';
import RockingChairImg from '../../assets/rocking_chair.png';
import { BLACK, CANDY_RED, HONEY } from '../../theme';

import { GHOST_API } from '../../ghost';

import {
  theme,
  ArticleContainer,
  ShareContainer,
  ShareText,
  SubscribeContainer,
  ShareButtons,
  SubscribeImage,
  SubscribeFormContainer,
  SubscribeHeader,
  SubscribeText,
  SubscribeWrapper,
} from './Article.styles';

const colors = {
  body: BLACK,
  link: HONEY,
  title: BLACK,
  header: BLACK,
  quote: BLACK,
  backto: BLACK,
  published: BLACK,
  author: BLACK,
  readtime: CANDY_RED,
};

const fonts = {
  title: 'Lato',
  header: 'Lato',
  body: 'Lato',
  backto: 'Lato',
};

const Article = () => {
  const article = ghost.hooks.useSelectedArticle();

  return (
    <>
      <ArticleContainer>
        <ThemeProvider theme={theme}>
          <GhostArticle
            ghostApi={GHOST_API}
            colors={colors}
            domain="https://www.backthenhistory.com"
            fonts={fonts}
          />
        </ThemeProvider>
        <ShareContainer>
          <ShareText>Share this article</ShareText>
          <ShareButtons>
            <FacebookShareButton
              appId="891815364676442"
              url={`https://www.backthenhistory.com/articles/${article.slug}`}
              description={article.title}
            />
            <PinterestShareButton
              appId="1464020"
              url={`https://www.backthenhistory.com/articles/${article.slug}`}
              description={article.title}
              media=""
            />
            <TwitterShareButton
              body={`${article.title} - https://www.backthenhistory.com/articles/${article.slug}`}
              link={`https://www.backthenhistory.com/articles/${article.slug}`}
            />
            <EmailShareButton
              subject={`Check out: ${article.title}`}
              body={`Check out this article! https://www.backthenhistory.com/articles/${article.slug}`}
            />
          </ShareButtons>
        </ShareContainer>
      </ArticleContainer>

      <SubscribeContainer>
        <SubscribeWrapper>
          <SubscribeImage
            src={RockingChairImg}
            alt="card showing the history of rocking chairs"
          />
          <SubscribeFormContainer>
            <SubscribeHeader>
              Your go-to guide for weird history facts
            </SubscribeHeader>
            <SubscribeText>
              Subscribe to the FREE daily email that makes learning about
              history fun.
            </SubscribeText>
            <SubscribeForm
              requestData={{
                signup_provider: `footer-${article.title
                  .toLowerCase()
                  .replace(/ /g, '-')}`,
              }}
            />
          </SubscribeFormContainer>
        </SubscribeWrapper>
      </SubscribeContainer>
    </>
  );
};

export default Article;
